/**
 * Helper para obtener las iniciales de un usuario de la sesión.
 *
 * Prioridad de datos:
 *  1. FirstName + LastName  -> "AC"
 *  2. FirstName | LastName   -> "A" | "C"
 *  3. UserName | Email       -> dos primeras letras (palabra única)
 *
 * Se usa como contenido del avatar cuando el usuario no tiene imagen de perfil.
 */
export default {
  getInitials (user) {
    if (!user) return '';

    const first = (user.firstName || '').trim();
    const last = (user.lastName || '').trim();

    if (first && last) {
      return (first.charAt(0) + last.charAt(0)).toUpperCase();
    }

    const fallback = first || last || (user.userName || '').trim() || (user.email || '').trim();
    if (!fallback) return '';

    const words = fallback.split(/\s+/).filter(word => word.length > 0);
    if (words.length > 1) {
      return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
    }

    return fallback.substring(0, 2).toUpperCase();
  }
}
